import { useMemo } from 'react';
import { IncludePart, PartProvider } from '@paypalcorp/pp-react-template';
import { css, useTheme, jsx } from '@emotion/react';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { devWarning, utilStyles } from '@paypalcorp/pp-react-utils';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function styles(tokens) {
  /* istanbul ignore next */
  if (!Object.keys(tokens).length) {
    devWarning('Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react.');
    return {};
  }

  var sysColorBackgroundSurface = tokens.sysColorBackgroundSurface,
      sysSpaceSm = tokens.sysSpaceSm,
      sysSpaceMd = tokens.sysSpaceMd,
      sysSpaceJumbo = tokens.sysSpaceJumbo;

  var _utilStyles = utilStyles(tokens),
      elevationStyles = _utilStyles.elevationStyles;

  var base = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-rows: auto 1fr auto;\n    height: 100%;\n  "])));
  var header = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: ", " ", ";\n  "])), sysSpaceSm, sysSpaceMd);
  var footer = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding: ", " ", ";\n  "])), sysSpaceSm, sysSpaceMd);
  var content = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    position: relative;\n    overflow: hidden;\n    z-index: 0;\n\n    &:before {\n      content: '';\n      position: absolute;\n      top: -1rem;\n      left: 0;\n      right: 0;\n      display: block;\n      height: 1rem;\n      box-shadow: ", ";\n      z-index: -1;\n    }\n\n    &:after {\n      content: '';\n      position: absolute;\n      bottom: -1rem;\n      left: 0;\n      right: 0;\n      display: block;\n      height: 1rem;\n      box-shadow: ", ";\n      z-index: -1;\n    }\n  "])), elevationStyles.level3, elevationStyles.level3Above);
  var scroller = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    padding: 0 ", ";\n    height: 100%;\n    overflow: scroll;\n    background: linear-gradient(\n      to bottom,\n      ", ",\n      transparent ", ",\n      transparent calc(100% - ", "),\n      ", " 100%\n    );\n    background-attachment: local;\n  "])), sysSpaceMd, sysColorBackgroundSurface, sysSpaceJumbo, sysSpaceJumbo, sysColorBackgroundSurface);
  return {
    base: base,
    header: header,
    footer: footer,
    content: content,
    scroller: scroller
  };
}

var ScrollBox = function (_ref) {
  var children = _ref.children,
      partMap = _ref.partMap;
  var tokens = useTheme();
  var scrollBoxStyles = useMemo(function () {
    return styles(tokens);
  }, [tokens]);
  var headerSection = jsx("header", {
    css: scrollBoxStyles.header,
    "data-ppui": "true"
  }, jsx(IncludePart, {
    name: "header",
    "data-ppui": "true"
  }));
  var footerSection = jsx("footer", {
    css: scrollBoxStyles.footer,
    "data-ppui": "true"
  }, jsx(IncludePart, {
    name: "footer",
    "data-ppui": "true"
  }));
  return jsx(PartProvider, {
    parts: children,
    partMap: partMap,
    anonymousName: "contents",
    "data-ppui": "true"
  }, jsx("section", {
    css: scrollBoxStyles.base,
    "data-ppui": "true"
  }, headerSection, jsx("div", {
    css: scrollBoxStyles.content,
    "data-ppui": "true"
  }, jsx("div", {
    css: scrollBoxStyles.scroller,
    "data-ppui": "true"
  }, jsx(IncludePart, {
    name: "contents",
    "data-ppui": "true"
  }))), footerSection));
};

export { ScrollBox };
